<template>
    <div class="china-map-page">
        <div class="map-content" ref="chinaMap"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import china from  "../../../public/libs/echarts/china.json";
echarts.registerMap('china', china);
export default {
    name: "ChinaMap",
    props: {
        list: {
            type: Array,
            default(){
                return []
            }
        },
    },
    data(){
        return {
            // 获取修改的数据
            chartsMapList: [],
            myChart: null,
            // 轮播循环时，需要的定时器
            timer: null,
            // 构建地图的参数
            option:{},
            // 地图上所有区域的地图数据
            geoCoordMap:{},
            // 在地图上需要展示的区域的数据
            convertData:[],
            // 轮播时，选中的第几个区域
            areaIndex: 0,
        }
    },
    mounted(){
        this.myChart = echarts.init(this.$refs.chinaMap);
        window.addEventListener("resize", this.handleWindowResize);
        // this.initData();
    },
    beforeDestroy(){
        // window.removeEventListener("resize", this.handleWindowResize);
    },
    methods: {
        // 初始化数据
        initData(){
            if(this.myChart){
                this.initMap();
            }
        },

        // 初始化地图
        initMap(){
            // 34个行政区域的坐标位置
            this.geoCoordMap = {
                '台湾': [121.5135,25.0308],
                '黑龙江': [127.9688, 45.368],
                '内蒙古': [110.3467, 41.4899],
                "吉林": [125.8154, 44.2584],
                '北京': [116.4551, 40.2539],
                "辽宁": [123.1238, 42.1216],
                "河北": [114.4995, 38.1006],
                "天津": [117.4219, 39.4189],
                "山西": [112.3352, 37.9413],
                "陕西": [109.1162, 34.2004],
                "甘肃": [103.5901, 36.3043],
                "宁夏": [106.3586, 38.1775],
                "青海": [101.4038, 36.8207],
                "新疆": [87.9236, 43.5883],
                "西藏": [91.11, 29.97],
                "四川": [103.9526, 30.7617],
                "重庆": [108.384366, 30.439702],
                "山东": [117.1582, 36.8701],
                "河南": [113.4668, 34.6234],
                "江苏": [120.0586, 32.915],
                "安徽": [117.29, 32.0581],
                "湖北": [114.3896, 30.6628],
                "浙江": [119.5313, 29.8773],
                "福建": [119.4543, 25.9222],
                "江西": [116.0046, 28.6633],
                "湖南": [113.0823, 28.2568],
                "贵州": [106.6992, 26.7682],
                "云南": [102.9199, 25.4663],
                "广东": [113.12244, 23.009505],
                "广西": [108.479, 23.1152],
                "海南": [110.3893, 19.8516],
                '上海': [121.4648, 31.2891],
                '香港': [114.2578,22.3242],
                '澳门': [113.5547,22.1484]
            };

            this.option = {
                backgroundColor: 'transparent',
                animation: true,
                animationDuration: 1000,
                tooltip: {
                    trigger: 'item',
                    triggerOn: "none",
                    backgroundColor: 'transparent',
                    padding: 0,
                    showDelay: 0,
                    hideDelay: 0,
                    borderColor: 'transparent',
                    borderWidth: 0,
                    extraCssText: 'z-index:100;box-shadow:none',
                    confine: true,
                    position: function (pos, params, dom, rect, size) {
                        const obj = {
                            left: pos[0] - (size.contentSize[0]*1.3),
                            top: pos[1] - (size.contentSize[1])
                        };
                        return obj;
                    },
                    formatter(params){
                        return `<div class="tooltip">
                            <p class="name">${params.data.province}</p>
                            <p>
								<span>商场数：${params.data.storeCount}</span>
							</p>
                            <p>
								<span>屏幕数：${params.data.deviceCount}</span>
							</p>
                        </div>`
                    }
                },
                geo: {
                    map: "china",
                    aspectScale: 0.85,
                    layoutCenter: ["50%", "55%"],
                    layoutSize: '120%',
                    silent: true,
                    itemStyle: {
                        borderWidth: 0,
                        shadowColor: 'rgba(11,192,251,0.8)',
                        shadowOffsetX: 0,
                        shadowOffsetY: 15,
                        opacity: 0.5,
                    },
                    label: {
                        show: false
                    },
                    emphasis: {
                        areaColor: 'rgba(9,231,249,0.5)'
                    },
                    regions: [{
                        name: '南海诸岛',
                        itemStyle: {
                            areaColor: 'rgba(0, 10, 52, 1)',
                            borderColor: 'rgba(0, 10, 52, 1)',
                            label: {
                                show: false,
                                color: "#009cc9"
                            },
                            opacity: 0,
                        },
                        label: {
                            show: false,
                            color: '#FFFFFF',
                            fontSize: 12
                        }
                    }],
                },
                series: [{
                    type: 'map',
                    map: 'china',
                    aspectScale: 0.85,
                    layoutCenter: ['50%', '55%'],
                    layoutSize: '120%',
                    zoom: 1,
                    scaleLimit: {
                        min: 1,
                        max: 2
                    },
                    itemStyle: {
                        borderColor: 'rgba(18, 58, 55, 1.0)',
                        borderWidth: 1,
                        areaColor: {
                            type: 'linear-gradient',
                            x: 300,
                            y: -300,
                            x2: 800,
                            y2: 400,
                            colorStops: [{
                                offset: 0,
                                color: '#14E6E5' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#F0A395' // 50% 处的颜色
                            }],
                            global: true // 缺省为 false
                        },
                    },
                    emphasis: {
                        itemStyle: {
                            areaColor: '#009DA1',
                        },
                        label: {
                            show: false,
                            color: "#fff",
                            offset: [0, 20]
                        }
                    },
                    silent: true,
                    data: []
                }, {
                    type: "effectScatter",
                    coordinateSystem: "geo",
                    zlevel: 2,
                    symbolSize: 8,
                    rippleEffect: {
                        period: 3,
                        scale: 9,
                        brushType: 'stroke'
                    },
                    itemStyle: {
                        color:"#ff3f00"
                    },
                    silent: true,
                    data:[]
                }, {                                                        // 地图上的自定义图标展示
                    type: 'scatter',
                    coordinateSystem: 'geo',
                    symbol: 'image://data:image/png;base64,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',
                    symbolSize: [38, 52],
                    symbolOffset: [0, -25],
                    zlevel: 9,
                    data:[],
                }]
            };

            if(this.chartsMapList.length == 0) return;
            let convertData = function (){                       // 对地图上的数据进行改造
                let res = [];
                this.chartsMapList.map(item => {
                    Object.keys(this.geoCoordMap).forEach(v => {
                        if(item.province.includes(v)){
                            res.push({
                                ...item,
                                name: v,
                            })
                        }
                    })
                })
                return res;
            }.call(this);
            this.option.series[0].data = convertData;
            this.loopShow();
            // this.loopShowArea();
        },

        // 轮播提示
        loopShow(){
            this.timer = setInterval(this.loopShowArea(), 5200);
        },

        // 轮播只展示当前的区域
        loopShowArea(){
            if(this.chartsMapList.length != 0){
                let scatterData = function (){                    // 地图上的进行显示数据进行改造
                    let res = []
                    Object.keys(this.geoCoordMap).forEach(item => {
                        if(this.chartsMapList[this.areaIndex].province.includes(item)){
                            res.push({
                                ...this.chartsMapList[this.areaIndex],
                                name: item,
                                value: this.geoCoordMap[item]
                            })
                        }
                    });
                    return res;
                }.call(this);

                this.option.series[1].data = scatterData;
                this.option.series[2].data = scatterData;
            }
            this.myChart.setOption(this.option);
            this.myChart.dispatchAction({
                type: 'showTip',
                seriesIndex: 0,
                dataIndex: this.areaIndex
            });
            this.hideTip();
            this.myChart.dispatchAction({
                type: 'highlight',
                seriesIndex: 0,
                dataIndex: this.areaIndex
            });

            this.areaIndex++;
            if(this.areaIndex >= this.chartsMapList.length){
                this.areaIndex = 0;
            }

            return this.loopShowArea;
        },

        // 取消地图上所有高亮的函数
        hideTip(){
            this.myChart.dispatchAction({
                type: 'downplay',
                seriesIndex: 0
            })
        },

        // 自动调整 echarts 的大小
        handleWindowResize(){
            if(!this.myChart) return;
            this.myChart.resize();
        }
    },
    watch: {
        'list': {
            immediate: true,
            handler(value){
                // console.log(value, "value");
                this.chartsMapList = value;
                this.$nextTick(function (){
                    this.initData();
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.china-map-page{
    display: flex;
    width: 100%;
    height: 100%;
    .map-content{
        flex: 1;
    }
}
</style>

<style lang="scss">
// 提示框的样式
.tooltip {
    background: url('/img/kanban/bg.png') center center no-repeat;
    background-size: cover;
    width: 143px;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #cecfe2;
    // position: relative;
    box-sizing: border-box;
    padding: 10px 14px;
    padding-left: 30px;
    overflow: hidden;
    animation: yEaseInAnimate 1s ease 0s 1; /*调用动画：动画名、时间、时间线条、播放次数*/
    animation-fill-mode: forwards; /*定义动画结束的状态*/
    .name {
        font-size: 14px;
        line-height: 18px;
        color: #fff;
        margin-bottom: 6px;
        position: relative;
        animation: leftEaseInAnimate 1s ease 0.6s 1; /*调用动画：动画名、时间、时间线条、播放次数*/
        animation-fill-mode: forwards; /*定义动画结束的状态*/
        &:after {
            content: "";
            position: absolute;
            left: -12px;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            background: #ff3f00;
            border-radius: 3px;
        }
    }
    p {
        margin-bottom: 4px;
        font-size: 12px;
        line-height: 17px;
        display: flex;
        animation: rightEaseInAnimate 1s ease 0.6s 1; /*调用动画：动画名、时间、时间线条、播放次数*/
        animation-fill-mode: forwards; /*定义动画结束的状态*/
        span {
            flex: 1;
            &:nth-child(2n) {
                text-align: right;
            }
        }
    }
}

@keyframes rightEaseInAnimate {
    /*定义从右边滑入文字的动画*/
    0% {
        transform: translateX(100px);
        opacity: 0;
    }
    100% {
        transform: translateX(0px);
        opacity: 1;
    }
}

@keyframes leftEaseInAnimate {
    /*定义从右边滑入文字的动画*/
    0% {
        transform: translateX(-100px);
        opacity: 0;
    }
    100% {
        transform: translateX(0px);
        opacity: 1;
    }
}

@keyframes yEaseInAnimate {
    /*定义从右边滑入文字的动画*/
    0% {
        transform: translateY(300px);
        opacity: 0;
    }
    70% {
        transform: translateY(100px);
        opacity: 0;
    }
    100% {
        transform: translateX(0px);
        opacity: 1;
    }
}
</style>